import client from '../../client';
import {
  GET_UNSUBS_DATA,
  GET_UNSUBS_DATA_SUCCESS,
  GET_UNSUBS_DATA_FAIL,
  GET_UNSUBS_DATA_TOTAL,
  GET_UNSUBS_DATA_TOTAL_SUCCESS,
  GET_UNSUBS_DATA_TOTAL_FAIL,
  GET_UNSUBS_DRILL_DATA,
  GET_UNSUBS_DRILL_DATA_SUCCESS,
  GET_UNSUBS_DRILL_DATA_FAIL
} from '../constants/unsubs';

export const getUnSubsData = (params, graphId) => dispatch => {
  dispatch({
    type: GET_UNSUBS_DATA,
    graphId
  });

  client
    .get('/unsubs', { params })
    .then(res => {
      dispatch({
        type: GET_UNSUBS_DATA_SUCCESS,
        data: res.data,
        graphId
      });
    })
    .catch(error => {
      dispatch({
        type: GET_UNSUBS_DATA_FAIL,
        error,
        graphId
      })
    });
}

export const getUnsubsDrillData = (params) => dispatch => {
  dispatch({
    type: GET_UNSUBS_DRILL_DATA
  });

  client
    .get('/unsubs/drill', { params })
    .then(res => {
      dispatch({
        type: GET_UNSUBS_DRILL_DATA_SUCCESS,
        data: res.data
      });
    })
    .catch(error => {
      dispatch({
        type: GET_UNSUBS_DRILL_DATA_FAIL,
        error
      })
    })
}

export const getUnSubsDataTotal = (params, graphId) => dispatch => {
  dispatch({
    type: GET_UNSUBS_DATA_TOTAL,
    graphId
  });

  client
    .get('/unsubs/total', { params })
    .then(res => {
      dispatch({
        type: GET_UNSUBS_DATA_TOTAL_SUCCESS,
        data: res.data,
        graphId
      });
    })
    .catch(error => {
      dispatch({
        type: GET_UNSUBS_DATA_TOTAL_FAIL,
        error,
        graphId
      })
    });
}



// WEBPACK FOOTER //
// ./src/redux/actions/unsubs.js